const DummyData = {
  events: [
    {
      eventId: 'event-0',
      venueCode: 'VENUE-0',
      city: 'Aarhus',
      name: '1000Fryd',
      eventDateTime: '2019-04-27T14:48:56.601Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.91746',
      venueLongitude: '57.050222',
      venueName: '1000Fryd',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-1',
      venueCode: 'VENUE-1',
      city: 'Aarhus',
      name: 'Alive Festival',
      eventDateTime: '2019-04-28T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '8.690743',
      venueLongitude: '56.956431',
      venueName: 'Alive Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-2',
      venueCode: 'VENUE-2',
      city: 'Aarhus',
      name: 'Amager Bio // BETA',
      eventDateTime: '2019-04-29T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.609137',
      venueLongitude: '55.658072',
      venueName: 'Amager Bio // BETA',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-3',
      venueCode: 'VENUE-3',
      city: 'Aarhus',
      name: 'Borgerforeningen Kulturhus Svendborg',
      eventDateTime: '2019-04-30T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.6085430000001',
      venueLongitude: '55.059933',
      venueName: 'Borgerforeningen Kulturhus Svendborg',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-4',
      venueCode: 'VENUE-4',
      city: 'Aarhus',
      name: 'Bork Havn Musikfestival',
      eventDateTime: '2019-05-01T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '8.283028',
      venueLongitude: '55.848289',
      venueName: 'Bork Havn Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-5',
      venueCode: 'VENUE-5',
      city: 'Aarhus',
      name: 'Brovst Musikforsyning',
      eventDateTime: '2019-05-02T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.48582',
      venueLongitude: '57.089203',
      venueName: 'Brovst Musikforsyning',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-6',
      venueCode: 'VENUE-6',
      city: 'Aarhus',
      name: 'Bygningen i Vejle',
      eventDateTime: '2019-05-03T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.534041',
      venueLongitude: '55.711252',
      venueName: 'Bygningen i Vejle',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-7',
      venueCode: 'VENUE-7',
      city: 'Aarhus',
      name: 'Cafe Blågårds Apotek',
      eventDateTime: '2019-05-04T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.558032',
      venueLongitude: '55.686482',
      venueName: 'Cafe Blågårds Apotek',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-8',
      venueCode: 'VENUE-8',
      city: 'Aarhus',
      name: 'Café von Hatten',
      eventDateTime: '2019-05-05T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.032858',
      venueLongitude: '56.460659',
      venueName: 'Café von Hatten',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-9',
      venueCode: 'VENUE-9',
      city: 'Aarhus',
      name: 'Copenhagen Jazz House',
      eventDateTime: '2019-05-06T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.577641',
      venueLongitude: '55.679354',
      venueName: 'Copenhagen Jazz House',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-10',
      venueCode: 'VENUE-10',
      city: 'Aarhus',
      name: 'Copenhell',
      eventDateTime: '2019-05-07T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.6202011',
      venueLongitude: '55.6930679',
      venueName: 'Copenhell',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-11',
      venueCode: 'VENUE-11',
      city: 'Aarhus',
      name: 'CultHus',
      eventDateTime: '2019-05-08T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '11.865234',
      venueLongitude: '54.769009',
      venueName: 'CultHus',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-12',
      venueCode: 'VENUE-12',
      city: 'Aarhus',
      name: 'Culture Box',
      eventDateTime: '2019-05-09T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.583909',
      venueLongitude: '55.68642',
      venueName: 'Culture Box',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-13',
      venueCode: 'VENUE-13',
      city: 'Aarhus',
      name: 'Det Bruunske Pakhus',
      eventDateTime: '2019-05-10T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.753917',
      venueLongitude: '55.566738',
      venueName: 'Det Bruunske Pakhus',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-14',
      venueCode: 'VENUE-14',
      city: 'Aarhus',
      name: 'Det Musiske Hus',
      eventDateTime: '2019-05-11T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.533078',
      venueLongitude: '57.440526',
      venueName: 'Det Musiske Hus',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-15',
      venueCode: 'VENUE-15',
      city: 'Aarhus',
      name: 'DR Koncerthuset',
      eventDateTime: '2019-05-12T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.590203',
      venueLongitude: '55.658246',
      venueName: 'DR Koncerthuset',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-16',
      venueCode: 'VENUE-16',
      city: 'Aarhus',
      name: 'Esbjerg Rock Festival',
      eventDateTime: '2019-05-13T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '8.447494',
      venueLongitude: '55.466852',
      venueName: 'Esbjerg Rock Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-17',
      venueCode: 'VENUE-17',
      city: 'Aarhus',
      name: 'Fermaten',
      eventDateTime: '2019-05-14T14:48:56.602Z',
      soldOut: true,
      url: '#',
      venueLatitude: '8.970169',
      venueLongitude: '56.13684',
      venueName: 'Fermaten',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-18',
      venueCode: 'VENUE-18',
      city: 'Aarhus',
      name: 'Fonden VoxHall',
      eventDateTime: '2019-05-15T14:48:56.602Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.198913',
      venueLongitude: '56.155761',
      venueName: 'Fonden VoxHall',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-19',
      venueCode: 'VENUE-19',
      city: 'Aarhus',
      name: 'Forbrændingen',
      eventDateTime: '2019-05-16T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.356564',
      venueLongitude: '55.657697',
      venueName: 'Forbrændingen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-20',
      venueCode: 'VENUE-20',
      city: 'Aarhus',
      name: 'Gazzværket',
      eventDateTime: '2019-05-17T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.42320599999994',
      venueLongitude: '55.04482',
      venueName: 'Gazzværket',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-21',
      venueCode: 'VENUE-21',
      city: 'Aarhus',
      name: 'Gimle',
      eventDateTime: '2019-05-18T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.071454',
      venueLongitude: '55.63982',
      venueName: 'Gimle',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-22',
      venueCode: 'VENUE-22',
      city: 'Aarhus',
      name: 'Gjethuset',
      eventDateTime: '2019-05-19T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.022308',
      venueLongitude: '55.971284',
      venueName: 'Gjethuset',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-23',
      venueCode: 'VENUE-23',
      city: 'Aarhus',
      name: 'Global Copenhagen',
      eventDateTime: '2019-05-20T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.560634',
      venueLongitude: '55.691539',
      venueName: 'Global Copenhagen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-24',
      venueCode: 'VENUE-24',
      city: 'Aarhus',
      name: 'Godset',
      eventDateTime: '2019-05-21T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.483278',
      venueLongitude: '55.490988',
      venueName: 'Godset',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-25',
      venueCode: 'VENUE-25',
      city: 'Aarhus',
      name: 'Grøn Koncert',
      eventDateTime: '2019-05-22T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.186605',
      venueLongitude: '56.140359',
      venueName: 'Grøn Koncert',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-26',
      venueCode: 'VENUE-26',
      city: 'Aarhus',
      name: 'Grønnegades Kaserne',
      eventDateTime: '2019-05-23T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '11.763203',
      venueLongitude: '55.23182',
      venueName: 'Grønnegades Kaserne',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-27',
      venueCode: 'VENUE-27',
      city: 'Aarhus',
      name: 'Gutter Island Garagerock Festival',
      eventDateTime: '2019-05-24T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '11.882327',
      venueLongitude: '54.987295',
      venueName: 'Gutter Island Garagerock Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-28',
      venueCode: 'VENUE-28',
      city: 'Aarhus',
      name: 'Gæstgiveren',
      eventDateTime: '2019-05-25T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '14.800702',
      venueLongitude: '55.277009',
      venueName: 'Gæstgiveren',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-29',
      venueCode: 'VENUE-29',
      city: 'Aarhus',
      name: 'Hagges Musik Pub',
      eventDateTime: '2019-05-26T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '8.86263',
      venueLongitude: '54.935047',
      venueName: 'Hagges Musik Pub',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-30',
      venueCode: 'VENUE-30',
      city: 'Aarhus',
      name: 'Haze over Haarum',
      eventDateTime: '2019-05-27T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '8.289514',
      venueLongitude: '56.553606',
      venueName: 'Haze over Haarum',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-31',
      venueCode: 'VENUE-31',
      city: 'Aarhus',
      name: 'Heartland Festival',
      eventDateTime: '2019-05-28T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.488334',
      venueLongitude: '55.176965',
      venueName: 'Heartland Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-32',
      venueCode: 'VENUE-32',
      city: 'Aarhus',
      name: 'Huset-KBH',
      eventDateTime: '2019-05-29T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.574738',
      venueLongitude: '55.676372',
      venueName: 'Huset-KBH',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-33',
      venueCode: 'VENUE-33',
      city: 'Aarhus',
      name: 'Jelling Musikfestival',
      eventDateTime: '2019-05-30T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.418568',
      venueLongitude: '55.754827',
      venueName: 'Jelling Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-34',
      venueCode: 'VENUE-34',
      city: 'Aarhus',
      name: 'KB18',
      eventDateTime: '2019-05-31T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.558768',
      venueLongitude: '55.66598',
      venueName: 'KB18',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-35',
      venueCode: 'VENUE-35',
      city: 'Aarhus',
      name: 'Kedehuset',
      eventDateTime: '2019-06-01T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.55688399999997',
      venueLongitude: '56.171243',
      venueName: 'Kedehuset',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-36',
      venueCode: 'VENUE-36',
      city: 'Aarhus',
      name: 'Klaverfabrikken',
      eventDateTime: '2019-06-02T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.296973',
      venueLongitude: '55.927298',
      venueName: 'Klaverfabrikken',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-37',
      venueCode: 'VENUE-37',
      city: 'Aarhus',
      name: 'Klejtrup Musikefterskole',
      eventDateTime: '2019-06-03T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.627167',
      venueLongitude: '56.595005',
      venueName: 'Klejtrup Musikefterskole',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-38',
      venueCode: 'VENUE-38',
      city: 'Aarhus',
      name: 'Kløften Festival',
      eventDateTime: '2019-06-04T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.525146',
      venueLongitude: '55.22589',
      venueName: 'Kløften Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-39',
      venueCode: 'VENUE-39',
      city: 'Aarhus',
      name: 'Kulisselageret',
      eventDateTime: '2019-06-05T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.847619',
      venueLongitude: '55.863108',
      venueName: 'Kulisselageret',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-40',
      venueCode: 'VENUE-40',
      city: 'Aarhus',
      eventDateTime: '2019-06-06T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.73764800000004',
      venueLongitude: '57.151636',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-41',
      venueCode: 'VENUE-41',
      city: 'Aarhus',
      name: 'Kulturhuset Ishøj Kultur Café',
      eventDateTime: '2019-06-07T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.3562947',
      venueLongitude: '55.6128665',
      venueName: 'Kulturhuset Ishøj Kultur Café',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-42',
      venueCode: 'VENUE-42',
      city: 'Aarhus',
      name: 'Kulturhuset Islands Brygge',
      eventDateTime: '2019-06-08T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.576235',
      venueLongitude: '55.666846',
      venueName: 'Kulturhuset Islands Brygge',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-43',
      venueCode: 'VENUE-43',
      city: 'Aarhus',
      name: 'Krudttønden',
      eventDateTime: '2019-06-09T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.574095',
      venueLongitude: '55.7057',
      venueName: 'Krudttønden',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-44',
      venueCode: 'VENUE-44',
      city: 'Aarhus',
      name: 'Kulturkajen Docken',
      eventDateTime: '2019-06-10T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.597947',
      venueLongitude: '55.718621',
      venueName: 'Kulturkajen Docken',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-45',
      venueCode: 'VENUE-45',
      city: 'Aarhus',
      name: 'Kulturmaskinen',
      eventDateTime: '2019-06-11T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.381103',
      venueLongitude: '55.394797',
      venueName: 'Kulturmaskinen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-46',
      venueCode: 'VENUE-46',
      city: 'Aarhus',
      name: 'Kulturstationen Vanløse',
      eventDateTime: '2019-06-12T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.491019',
      venueLongitude: '55.687078',
      venueName: 'Kulturstationen Vanløse',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-47',
      venueCode: 'VENUE-47',
      city: 'Aarhus',
      name: 'Kulturværftet // Toldkammeret',
      eventDateTime: '2019-06-13T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.6126323999999',
      venueLongitude: '56.0383121',
      venueName: 'Kulturværftet // Toldkammeret',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-48',
      venueCode: 'VENUE-48',
      city: 'Aarhus',
      name: 'Loppen',
      eventDateTime: '2019-06-14T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.597078',
      venueLongitude: '55.673854',
      venueName: 'Loppen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-49',
      venueCode: 'VENUE-49',
      city: 'Aarhus',
      name: 'MantziusLive',
      eventDateTime: '2019-06-15T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.428294',
      venueLongitude: '55.84176',
      venueName: 'MantziusLive',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-50',
      venueCode: 'VENUE-50',
      city: 'Aarhus',
      name: 'MOJO BLUES BAR',
      eventDateTime: '2019-06-16T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.573678',
      venueLongitude: '55.675764',
      venueName: 'MOJO BLUES BAR',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-51',
      venueCode: 'VENUE-51',
      city: 'Aarhus',
      name: 'Musik I Lejet',
      eventDateTime: '2019-06-17T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.080801',
      venueLongitude: '56.060791',
      venueName: 'Musik I Lejet',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-52',
      venueCode: 'VENUE-52',
      city: 'Aarhus',
      name: 'Musikforeningen 5-øren',
      eventDateTime: '2019-06-18T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.610714',
      venueLongitude: '55.653324',
      venueName: 'Musikforeningen 5-øren',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-53',
      venueCode: 'VENUE-53',
      city: 'Aarhus',
      name: 'Musikforeningen Bygningen',
      eventDateTime: '2019-06-19T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.185211',
      venueLongitude: '55.455376',
      venueName: 'Musikforeningen Bygningen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-54',
      venueCode: 'VENUE-54',
      city: 'Aarhus',
      name: 'Musikhuzet Bornholm',
      eventDateTime: '2019-06-20T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '14.698992',
      venueLongitude: '55.10244',
      venueName: 'Musikhuzet Bornholm',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-55',
      venueCode: 'VENUE-55',
      city: 'Aarhus',
      name: 'Musikklubben Elværket',
      eventDateTime: '2019-06-21T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '11.401691',
      venueLongitude: '55.652226',
      venueName: 'Musikklubben Elværket',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-56',
      venueCode: 'VENUE-56',
      city: 'Aarhus',
      name: 'Nibe Festival',
      eventDateTime: '2019-06-22T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.63501',
      venueLongitude: '56.980911',
      venueName: 'Nibe Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-57',
      venueCode: 'VENUE-57',
      city: 'Aarhus',
      name: 'Nord-Als Musikfestival',
      eventDateTime: '2019-06-23T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.764318',
      venueLongitude: '55.047032',
      venueName: 'Nord-Als Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-58',
      venueCode: 'VENUE-58',
      city: 'Aarhus',
      name: 'Nordatlantens Brygge',
      eventDateTime: '2019-06-24T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.596465',
      venueLongitude: '55.677664',
      venueName: 'Nordatlantens Brygge',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-59',
      venueCode: 'VENUE-59',
      city: 'Aarhus',
      name: 'Northside Festival',
      eventDateTime: '2019-06-25T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.0893331',
      venueLongitude: '56.3086727',
      venueName: 'Northside Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-60',
      venueCode: 'VENUE-60',
      city: 'Aarhus',
      name: 'Nygadehuset Aabenraa',
      eventDateTime: '2019-06-26T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.416126',
      venueLongitude: '55.045834',
      venueName: 'Nygadehuset Aabenraa',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-61',
      venueCode: 'VENUE-61',
      city: 'Aarhus',
      name: 'Open Air Varde',
      eventDateTime: '2019-06-27T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '8.4844072',
      venueLongitude: '55.6198162',
      venueName: 'Open Air Varde',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-62',
      venueCode: 'VENUE-62',
      city: 'Aarhus',
      name: 'Paletten',
      eventDateTime: '2019-06-28T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.399856',
      venueLongitude: '56.449967',
      venueName: 'Paletten',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-63',
      venueCode: 'VENUE-63',
      city: 'Aarhus',
      name: 'Pavillonen',
      eventDateTime: '2019-06-29T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.868769',
      venueLongitude: '56.413333',
      venueName: 'Pavillonen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-64',
      venueCode: 'VENUE-64',
      city: 'Aarhus',
      name: 'Portalen',
      eventDateTime: '2019-06-30T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.330856',
      venueLongitude: '55.598328',
      venueName: 'Portalen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-65',
      venueCode: 'VENUE-65',
      city: 'Aarhus',
      name: 'Posten // Dexter',
      eventDateTime: '2019-07-01T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.383912',
      venueLongitude: '55.400764',
      venueName: 'Posten // Dexter',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-66',
      venueCode: 'VENUE-66',
      city: 'Aarhus',
      name: 'RADAR',
      eventDateTime: '2019-07-02T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.212726',
      venueLongitude: '56.159923',
      venueName: 'RADAR',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-67',
      venueCode: 'VENUE-67',
      city: 'Aarhus',
      name: 'Rock Under Broen',
      eventDateTime: '2019-07-03T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.7609341',
      venueLongitude: '55.5162165',
      venueName: 'Rock Under Broen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-68',
      venueCode: 'VENUE-68',
      city: 'Aarhus',
      name: 'Roskilde Festival',
      eventDateTime: '2019-07-04T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.079199',
      venueLongitude: '55.621952',
      venueName: 'Roskilde Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-69',
      venueCode: 'VENUE-69',
      city: 'Aarhus',
      name: 'RUST',
      eventDateTime: '2019-07-05T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.559304',
      venueLongitude: '55.691198',
      venueName: 'RUST',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-70',
      venueCode: 'VENUE-70',
      city: 'Aarhus',
      name: 'Råhuset',
      eventDateTime: '2019-07-06T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.560277',
      venueLongitude: '55.669801',
      venueName: 'Råhuset',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-71',
      venueCode: 'VENUE-71',
      city: 'Aarhus',
      name: 'Samsø Festival',
      eventDateTime: '2019-07-07T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.582541',
      venueLongitude: '55.833707',
      venueName: 'Samsø Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-72',
      venueCode: 'VENUE-72',
      city: 'Aarhus',
      name: 'Skagen Festival',
      eventDateTime: '2019-07-08T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.589818',
      venueLongitude: '57.723386',
      venueName: 'Skagen Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-73',
      venueCode: 'VENUE-73',
      city: 'Aarhus',
      name: 'Skråen i Nordkraft',
      eventDateTime: '2019-07-09T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.931544',
      venueLongitude: '57.046748',
      venueName: 'Skråen i Nordkraft',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-74',
      venueCode: 'VENUE-74',
      city: 'Aarhus',
      name: 'Slagelse Musikhus',
      eventDateTime: '2019-07-10T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '11.352302',
      venueLongitude: '55.406615',
      venueName: 'Slagelse Musikhus',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-75',
      venueCode: 'VENUE-75',
      city: 'Aarhus',
      name: 'Smukfest',
      eventDateTime: '2019-07-11T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.92629099999999',
      venueLongitude: '56.024968',
      venueName: 'Smukfest',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-76',
      venueCode: 'VENUE-76',
      city: 'Aarhus',
      name: 'Spillestedet Hansted',
      eventDateTime: '2019-07-12T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.6057589',
      venueLongitude: '55.0586582',
      venueName: 'Spillestedet Hansted',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-77',
      venueCode: 'VENUE-77',
      city: 'Aarhus',
      name: 'Spillestedet Harders',
      eventDateTime: '2019-07-13T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.610664',
      venueLongitude: '55.060602',
      venueName: 'Spillestedet Harders',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-78',
      venueCode: 'VENUE-78',
      city: 'Aarhus',
      name: 'Spillestedet Stengade',
      eventDateTime: '2019-07-14T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.555854',
      venueLongitude: '55.68813',
      venueName: 'Spillestedet Stengade',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-79',
      venueCode: 'VENUE-79',
      city: 'Aarhus',
      name: 'Spillestedet Thy',
      eventDateTime: '2019-07-15T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '8.69075199999997',
      venueLongitude: '56.956506',
      venueName: 'Spillestedet Thy',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-80',
      venueCode: 'VENUE-80',
      city: 'Aarhus',
      name: 'STARS',
      eventDateTime: '2019-07-16T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '11.909529',
      venueLongitude: '55.008287',
      venueName: 'STARS',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-81',
      venueCode: 'VENUE-81',
      city: 'Aarhus',
      name: 'Studenterhus Odense',
      eventDateTime: '2019-07-17T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.380921',
      venueLongitude: '55.3951',
      venueName: 'Studenterhus Odense',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-82',
      venueCode: 'VENUE-82',
      city: 'Aarhus',
      name: 'Studenterhus Aarhus',
      eventDateTime: '2019-07-18T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.200434',
      venueLongitude: '56.171217',
      venueName: 'Studenterhus Aarhus',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-83',
      venueCode: 'VENUE-83',
      city: 'Aarhus',
      name: 'Studenterhuset',
      eventDateTime: '2019-07-19T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.919696',
      venueLongitude: '57.048238',
      venueName: 'Studenterhuset',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-84',
      venueCode: 'VENUE-84',
      city: 'Aarhus',
      name: 'Sølund Musikfestival',
      eventDateTime: '2019-07-20T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.919902',
      venueLongitude: '56.028077',
      venueName: 'Sølund Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-85',
      venueCode: 'VENUE-85',
      city: 'Aarhus',
      name: 'Sønderborghus',
      eventDateTime: '2019-07-21T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.793824',
      venueLongitude: '54.9113',
      venueName: 'Sønderborghus',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-86',
      venueCode: 'VENUE-86',
      city: 'Aarhus',
      name: 'Tapperiet',
      eventDateTime: '2019-07-22T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.19261',
      venueLongitude: '55.45107',
      venueName: 'Tapperiet',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-87',
      venueCode: 'VENUE-87',
      city: 'Aarhus',
      name: 'Templet',
      eventDateTime: '2019-07-23T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.499821',
      venueLongitude: '55.770169',
      venueName: 'Templet',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-88',
      venueCode: 'VENUE-88',
      city: 'Aarhus',
      name: 'Tinderbox',
      eventDateTime: '2019-07-24T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.34025',
      venueLongitude: '55.382023',
      venueName: 'Tinderbox',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-89',
      venueCode: 'VENUE-89',
      city: 'Aarhus',
      name: 'Tivoli - Fredags Rock',
      eventDateTime: '2019-07-25T14:48:56.603Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.5681471',
      venueLongitude: '55.6736841',
      venueName: 'Tivoli - Fredags Rock',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-90',
      venueCode: 'VENUE-90',
      city: 'Aarhus',
      name: 'Tobakken',
      eventDateTime: '2019-07-26T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '8.45944',
      venueLongitude: '55.464693',
      venueName: 'Tobakken',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-91',
      venueCode: 'VENUE-91',
      city: 'Aarhus',
      name: 'Tobaksgaarden',
      eventDateTime: '2019-07-27T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '9.897599',
      venueLongitude: '55.270046',
      venueName: 'Tobaksgaarden',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-92',
      venueCode: 'VENUE-92',
      city: 'Aarhus',
      name: 'Train',
      eventDateTime: '2019-07-28T14:48:56.603Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.212054',
      venueLongitude: '56.152255',
      venueName: 'Train',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-93',
      venueCode: 'VENUE-93',
      city: 'Aarhus',
      name: 'Tunø Festival',
      eventDateTime: '2019-07-29T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '10.433347',
      venueLongitude: '55.949053',
      venueName: 'Tunø Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-94',
      venueCode: 'VENUE-94',
      city: 'Aarhus',
      name: 'Turbinen',
      eventDateTime: '2019-07-30T14:48:56.604Z',
      soldOut: true,
      url: '#',
      venueLatitude: '10.03243',
      venueLongitude: '56.464548',
      venueName: 'Turbinen',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-95',
      venueCode: 'VENUE-95',
      city: 'Aarhus',
      name: 'Tønder Festival',
      eventDateTime: '2019-07-31T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '8.862664',
      venueLongitude: '54.935048',
      venueName: 'Tønder Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-96',
      venueCode: 'VENUE-96',
      city: 'Aarhus',
      name: 'UHØRT',
      eventDateTime: '2019-08-01T14:48:56.604Z',
      soldOut: true,
      url: '#',
      venueLatitude: '12.6129645',
      venueLongitude: '55.6908516',
      venueName: 'UHØRT',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-97',
      venueCode: 'VENUE-97',
      city: 'Aarhus',
      name: 'Vega',
      eventDateTime: '2019-08-02T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.544332',
      venueLongitude: '55.667978',
      venueName: 'Vega',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-98',
      venueCode: 'VENUE-98',
      city: 'Aarhus',
      name: 'Vershuset',
      eventDateTime: '2019-08-03T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '11.7611',
      venueLongitude: '55.231929',
      venueName: 'Vershuset',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-99',
      venueCode: 'VENUE-99',
      city: 'Aarhus',
      name: 'Vesterhavsrock',
      eventDateTime: '2019-08-04T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.26604640000005',
      venueLongitude: '57.090281',
      venueName: 'Vesterhavsrock',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-100',
      venueCode: 'VENUE-100',
      city: 'Aarhus',
      name: 'Vesthimmerlands Musikhus ALFA',
      eventDateTime: '2019-08-05T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '9.52272',
      venueLongitude: '56.80135',
      venueName: 'Vesthimmerlands Musikhus ALFA',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-101',
      venueCode: 'VENUE-101',
      city: 'Aarhus',
      name: 'Viften',
      eventDateTime: '2019-08-06T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '12.4566722',
      venueLongitude: '55.6818188',
      venueName: 'Viften',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-102',
      venueCode: 'VENUE-102',
      city: 'Aarhus',
      name: 'Vig Festival',
      eventDateTime: '2019-08-07T14:48:56.604Z',
      soldOut: false,
      url: '#',
      venueLatitude: '11.576766',
      venueLongitude: '55.852358',
      venueName: 'Vig Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-103',
      venueCode: 'VENUE-103',
      city: 'Aarhus',
      name: 'Vilde Vulkaner Festival',
      eventDateTime: '2019-08-08T14:48:56.604Z',
      soldOut: true,
      url: '#',
      venueLatitude: '11.907565',
      venueLongitude: '55.01133',
      venueName: 'Vilde Vulkaner Festival',
      venueCity: 'Aarhus',
    },
    {
      eventId: 'event-104',
      venueCode: 'VENUE-104',
      city: 'Aarhus',
      name: 'Wonderfestiwall',
      eventDateTime: '2019-08-09T14:48:56.604Z',
      soldOut: true,
      url: '#',
      venueLatitude: '14.798389',
      venueLongitude: '55.273815',
      venueName: 'Wonderfestiwall',
      venueCity: 'Aarhus',
    },
  ].map(item => ({ ...item, venueLatitude: Number(item.venueLatitude), venueLongitude: Number(item.venueLongitude) })),
  venues: [
    {
      venueLatitude: '9.91746',
      venueLongitude: '57.050222',
      venueCode: 'VENUE-0',
      venueName: '1000Fryd',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.690743',
      venueLongitude: '56.956431',
      venueCode: 'VENUE-1',
      venueName: 'Alive Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.609137',
      venueLongitude: '55.658072',
      venueCode: 'VENUE-2',
      venueName: 'Amager Bio // BETA',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.6085430000001',
      venueLongitude: '55.059933',
      venueCode: 'VENUE-3',
      venueName: 'Borgerforeningen Kulturhus Svendborg',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.283028',
      venueLongitude: '55.848289',
      venueCode: 'VENUE-4',
      venueName: 'Bork Havn Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.48582',
      venueLongitude: '57.089203',
      venueCode: 'VENUE-5',
      venueName: 'Brovst Musikforsyning',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.534041',
      venueLongitude: '55.711252',
      venueCode: 'VENUE-6',
      venueName: 'Bygningen i Vejle',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.558032',
      venueLongitude: '55.686482',
      venueCode: 'VENUE-7',
      venueName: 'Cafe Blågårds Apotek',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.032858',
      venueLongitude: '56.460659',
      venueCode: 'VENUE-8',
      venueName: 'Café von Hatten',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.577641',
      venueLongitude: '55.679354',
      venueCode: 'VENUE-9',
      venueName: 'Copenhagen Jazz House',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.6202011',
      venueLongitude: '55.6930679',
      venueCode: 'VENUE-10',
      venueName: 'Copenhell',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.865234',
      venueLongitude: '54.769009',
      venueCode: 'VENUE-11',
      venueName: 'CultHus',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.583909',
      venueLongitude: '55.68642',
      venueCode: 'VENUE-12',
      venueName: 'Culture Box',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.753917',
      venueLongitude: '55.566738',
      venueCode: 'VENUE-13',
      venueName: 'Det Bruunske Pakhus',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.533078',
      venueLongitude: '57.440526',
      venueCode: 'VENUE-14',
      venueName: 'Det Musiske Hus',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.590203',
      venueLongitude: '55.658246',
      venueCode: 'VENUE-15',
      venueName: 'DR Koncerthuset',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.447494',
      venueLongitude: '55.466852',
      venueCode: 'VENUE-16',
      venueName: 'Esbjerg Rock Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.970169',
      venueLongitude: '56.13684',
      venueCode: 'VENUE-17',
      venueName: 'Fermaten',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.198913',
      venueLongitude: '56.155761',
      venueCode: 'VENUE-18',
      venueName: 'Fonden VoxHall',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.356564',
      venueLongitude: '55.657697',
      venueCode: 'VENUE-19',
      venueName: 'Forbrændingen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.42320599999994',
      venueLongitude: '55.04482',
      venueCode: 'VENUE-20',
      venueName: 'Gazzværket',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.071454',
      venueLongitude: '55.63982',
      venueCode: 'VENUE-21',
      venueName: 'Gimle',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.022308',
      venueLongitude: '55.971284',
      venueCode: 'VENUE-22',
      venueName: 'Gjethuset',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.560634',
      venueLongitude: '55.691539',
      venueCode: 'VENUE-23',
      venueName: 'Global Copenhagen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.483278',
      venueLongitude: '55.490988',
      venueCode: 'VENUE-24',
      venueName: 'Godset',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.186605',
      venueLongitude: '56.140359',
      venueCode: 'VENUE-25',
      venueName: 'Grøn Koncert',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.763203',
      venueLongitude: '55.23182',
      venueCode: 'VENUE-26',
      venueName: 'Grønnegades Kaserne',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.882327',
      venueLongitude: '54.987295',
      venueCode: 'VENUE-27',
      venueName: 'Gutter Island Garagerock Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '14.800702',
      venueLongitude: '55.277009',
      venueCode: 'VENUE-28',
      venueName: 'Gæstgiveren',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.86263',
      venueLongitude: '54.935047',
      venueCode: 'VENUE-29',
      venueName: 'Hagges Musik Pub',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.289514',
      venueLongitude: '56.553606',
      venueCode: 'VENUE-30',
      venueName: 'Haze over Haarum',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.488334',
      venueLongitude: '55.176965',
      venueCode: 'VENUE-31',
      venueName: 'Heartland Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.574738',
      venueLongitude: '55.676372',
      venueCode: 'VENUE-32',
      venueName: 'Huset-KBH',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.418568',
      venueLongitude: '55.754827',
      venueCode: 'VENUE-33',
      venueName: 'Jelling Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.558768',
      venueLongitude: '55.66598',
      venueCode: 'VENUE-34',
      venueName: 'KB18',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.55688399999997',
      venueLongitude: '56.171243',
      venueCode: 'VENUE-35',
      venueName: 'Kedehuset',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.296973',
      venueLongitude: '55.927298',
      venueCode: 'VENUE-36',
      venueName: 'Klaverfabrikken',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.627167',
      venueLongitude: '56.595005',
      venueCode: 'VENUE-37',
      venueName: 'Klejtrup Musikefterskole',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.525146',
      venueLongitude: '55.22589',
      venueCode: 'VENUE-38',
      venueName: 'Kløften Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.847619',
      venueLongitude: '55.863108',
      venueCode: 'VENUE-39',
      venueName: 'Kulisselageret',
      venueCity: 'Aarhus',
    },
    { venueLatitude: '9.73764800000004', venueLongitude: '57.151636', venueCode: 'VENUE-40', venueCity: 'Aarhus' },
    {
      venueLatitude: '12.3562947',
      venueLongitude: '55.6128665',
      venueCode: 'VENUE-41',
      venueName: 'Kulturhuset Ishøj Kultur Café',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.576235',
      venueLongitude: '55.666846',
      venueCode: 'VENUE-42',
      venueName: 'Kulturhuset Islands Brygge',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.574095',
      venueLongitude: '55.7057',
      venueCode: 'VENUE-43',
      venueName: 'Krudttønden',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.597947',
      venueLongitude: '55.718621',
      venueCode: 'VENUE-44',
      venueName: 'Kulturkajen Docken',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.381103',
      venueLongitude: '55.394797',
      venueCode: 'VENUE-45',
      venueName: 'Kulturmaskinen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.491019',
      venueLongitude: '55.687078',
      venueCode: 'VENUE-46',
      venueName: 'Kulturstationen Vanløse',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.6126323999999',
      venueLongitude: '56.0383121',
      venueCode: 'VENUE-47',
      venueName: 'Kulturværftet // Toldkammeret',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.597078',
      venueLongitude: '55.673854',
      venueCode: 'VENUE-48',
      venueName: 'Loppen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.428294',
      venueLongitude: '55.84176',
      venueCode: 'VENUE-49',
      venueName: 'MantziusLive',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.573678',
      venueLongitude: '55.675764',
      venueCode: 'VENUE-50',
      venueName: 'MOJO BLUES BAR',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.080801',
      venueLongitude: '56.060791',
      venueCode: 'VENUE-51',
      venueName: 'Musik I Lejet',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.610714',
      venueLongitude: '55.653324',
      venueCode: 'VENUE-52',
      venueName: 'Musikforeningen 5-øren',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.185211',
      venueLongitude: '55.455376',
      venueCode: 'VENUE-53',
      venueName: 'Musikforeningen Bygningen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '14.698992',
      venueLongitude: '55.10244',
      venueCode: 'VENUE-54',
      venueName: 'Musikhuzet Bornholm',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.401691',
      venueLongitude: '55.652226',
      venueCode: 'VENUE-55',
      venueName: 'Musikklubben Elværket',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.63501',
      venueLongitude: '56.980911',
      venueCode: 'VENUE-56',
      venueName: 'Nibe Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.764318',
      venueLongitude: '55.047032',
      venueCode: 'VENUE-57',
      venueName: 'Nord-Als Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.596465',
      venueLongitude: '55.677664',
      venueCode: 'VENUE-58',
      venueName: 'Nordatlantens Brygge',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.0893331',
      venueLongitude: '56.3086727',
      venueCode: 'VENUE-59',
      venueName: 'Northside Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.416126',
      venueLongitude: '55.045834',
      venueCode: 'VENUE-60',
      venueName: 'Nygadehuset Aabenraa',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.4844072',
      venueLongitude: '55.6198162',
      venueCode: 'VENUE-61',
      venueName: 'Open Air Varde',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.399856',
      venueLongitude: '56.449967',
      venueCode: 'VENUE-62',
      venueName: 'Paletten',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.868769',
      venueLongitude: '56.413333',
      venueCode: 'VENUE-63',
      venueName: 'Pavillonen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.330856',
      venueLongitude: '55.598328',
      venueCode: 'VENUE-64',
      venueName: 'Portalen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.383912',
      venueLongitude: '55.400764',
      venueCode: 'VENUE-65',
      venueName: 'Posten // Dexter',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.212726',
      venueLongitude: '56.159923',
      venueCode: 'VENUE-66',
      venueName: 'RADAR',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.7609341',
      venueLongitude: '55.5162165',
      venueCode: 'VENUE-67',
      venueName: 'Rock Under Broen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.079199',
      venueLongitude: '55.621952',
      venueCode: 'VENUE-68',
      venueName: 'Roskilde Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.559304',
      venueLongitude: '55.691198',
      venueCode: 'VENUE-69',
      venueName: 'RUST',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.560277',
      venueLongitude: '55.669801',
      venueCode: 'VENUE-70',
      venueName: 'Råhuset',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.582541',
      venueLongitude: '55.833707',
      venueCode: 'VENUE-71',
      venueName: 'Samsø Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.589818',
      venueLongitude: '57.723386',
      venueCode: 'VENUE-72',
      venueName: 'Skagen Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.931544',
      venueLongitude: '57.046748',
      venueCode: 'VENUE-73',
      venueName: 'Skråen i Nordkraft',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.352302',
      venueLongitude: '55.406615',
      venueCode: 'VENUE-74',
      venueName: 'Slagelse Musikhus',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.92629099999999',
      venueLongitude: '56.024968',
      venueCode: 'VENUE-75',
      venueName: 'Smukfest',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.6057589',
      venueLongitude: '55.0586582',
      venueCode: 'VENUE-76',
      venueName: 'Spillestedet Hansted',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.610664',
      venueLongitude: '55.060602',
      venueCode: 'VENUE-77',
      venueName: 'Spillestedet Harders',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.555854',
      venueLongitude: '55.68813',
      venueCode: 'VENUE-78',
      venueName: 'Spillestedet Stengade',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.69075199999997',
      venueLongitude: '56.956506',
      venueCode: 'VENUE-79',
      venueName: 'Spillestedet Thy',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.909529',
      venueLongitude: '55.008287',
      venueCode: 'VENUE-80',
      venueName: 'STARS',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.380921',
      venueLongitude: '55.3951',
      venueCode: 'VENUE-81',
      venueName: 'Studenterhus Odense',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.200434',
      venueLongitude: '56.171217',
      venueCode: 'VENUE-82',
      venueName: 'Studenterhus Aarhus',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.919696',
      venueLongitude: '57.048238',
      venueCode: 'VENUE-83',
      venueName: 'Studenterhuset',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.919902',
      venueLongitude: '56.028077',
      venueCode: 'VENUE-84',
      venueName: 'Sølund Musikfestival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.793824',
      venueLongitude: '54.9113',
      venueCode: 'VENUE-85',
      venueName: 'Sønderborghus',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.19261',
      venueLongitude: '55.45107',
      venueCode: 'VENUE-86',
      venueName: 'Tapperiet',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.499821',
      venueLongitude: '55.770169',
      venueCode: 'VENUE-87',
      venueName: 'Templet',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.34025',
      venueLongitude: '55.382023',
      venueCode: 'VENUE-88',
      venueName: 'Tinderbox',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.5681471',
      venueLongitude: '55.6736841',
      venueCode: 'VENUE-89',
      venueName: 'Tivoli - Fredags Rock',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.45944',
      venueLongitude: '55.464693',
      venueCode: 'VENUE-90',
      venueName: 'Tobakken',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.897599',
      venueLongitude: '55.270046',
      venueCode: 'VENUE-91',
      venueName: 'Tobaksgaarden',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.212054',
      venueLongitude: '56.152255',
      venueCode: 'VENUE-92',
      venueName: 'Train',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.433347',
      venueLongitude: '55.949053',
      venueCode: 'VENUE-93',
      venueName: 'Tunø Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '10.03243',
      venueLongitude: '56.464548',
      venueCode: 'VENUE-94',
      venueName: 'Turbinen',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '8.862664',
      venueLongitude: '54.935048',
      venueCode: 'VENUE-95',
      venueName: 'Tønder Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.6129645',
      venueLongitude: '55.6908516',
      venueCode: 'VENUE-96',
      venueName: 'UHØRT',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.544332',
      venueLongitude: '55.667978',
      venueCode: 'VENUE-97',
      venueName: 'Vega',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.7611',
      venueLongitude: '55.231929',
      venueCode: 'VENUE-98',
      venueName: 'Vershuset',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.26604640000005',
      venueLongitude: '57.090281',
      venueCode: 'VENUE-99',
      venueName: 'Vesterhavsrock',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '9.52272',
      venueLongitude: '56.80135',
      venueCode: 'VENUE-100',
      venueName: 'Vesthimmerlands Musikhus ALFA',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '12.4566722',
      venueLongitude: '55.6818188',
      venueCode: 'VENUE-101',
      venueName: 'Viften',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.576766',
      venueLongitude: '55.852358',
      venueCode: 'VENUE-102',
      venueName: 'Vig Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '11.907565',
      venueLongitude: '55.01133',
      venueCode: 'VENUE-103',
      venueName: 'Vilde Vulkaner Festival',
      venueCity: 'Aarhus',
    },
    {
      venueLatitude: '14.798389',
      venueLongitude: '55.273815',
      venueCode: 'VENUE-104',
      venueName: 'Wonderfestiwall',
      venueCity: 'Aarhus',
    },
  ].map(item => ({ ...item, venueLatitude: Number(item.venueLongitude), venueLongitude: Number(item.venueLatitude) })),
};

export default DummyData;
